import { useState } from "react";
import { FormattedMessage } from "react-intl";

export default function usePermissions() {
  const getPermissions = () => localStorage.getItem("cargobase_userpermissions");
  const clearPermissions = () => localStorage.removeItem("cargobase_userpermissions");

  const [permissions, setPermissions] = useState(getPermissions());

  const parsedPermissions = JSON.parse(permissions || "{}");

  const getPaymentLocationLabel = () => {
    if (permissions) {
      const parsedPermissions = JSON.parse(permissions);
      return (
        parsedPermissions.payment_location?.label || (
          <FormattedMessage id="general.paymentLocation" defaultMessage="Payment location" />
        )
      );
    }
    return <FormattedMessage id="general.paymentLocation" defaultMessage="Payment location" />;
  };

  const getProviderTeamLabel = () => {
    if (permissions) {
      const parsedPermissions = JSON.parse(permissions);
      return (
        parsedPermissions.provider_teams?.label || (
          <FormattedMessage id="general.providerTeam" defaultMessage="Provider Team" />
        )
      );
    }
    return <FormattedMessage id="general.providerTeam" defaultMessage="Provider Team" />;
  };

  return {
    permissions,
    parsedPermissions,
    getPermissions,
    clearPermissions,
    setPermissions,
    getPaymentLocationLabel,
    getProviderTeamLabel,
  };
}
